// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Wo7N","paramInput":"JobSimulator_paramInput__1y7dH","input":"JobSimulator_input__Fbwpe"};